import { decorators } from '@sohohouse/platform-resources'
import { TIMES_OF_DAY } from '~/constants'

const { MORNING, AFTERNOON, EVENING, NIGHT } = TIMES_OF_DAY

export default () => {
  const { DateTime } = decorators.shared

  const { hour } = new DateTime()

  if (hour >= 0 && hour < 5) return NIGHT
  if (hour >= 5 && hour < 12) return MORNING
  if (hour >= 12 && hour < 18) return AFTERNOON

  return EVENING
}